import { render, staticRenderFns } from "./BrochureList.vue?vue&type=template&id=ae8988ba&lang=pug&"
import script from "./BrochureList.vue?vue&type=script&lang=ts&"
export * from "./BrochureList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports